import './HeroBlock.css';

export function HeroBlock() {
    return (
        <div className="d5-red-block">
            <div className="d5-red-num">SZ</div>
            <div className="d5-red-content">
                <div className="d5-red-tags">
                    <div className="d5-red-tag">One $9 Payment</div>
                    <div className="d5-red-tag highlight">No Subscription</div>
                </div>
                <h1 className="d5-red-headline">
                    Steam
                    <em>Asset</em>
                    Pack
                    <em>Generator</em>
                </h1>
            </div>
        </div>
    );
}
